import { render } from "./BackordersView.vue?vue&type=template&id=34c7b90e&scoped=true"
import script from "./BackordersView.vue?vue&type=script&lang=js"
export * from "./BackordersView.vue?vue&type=script&lang=js"

import "./BackordersView.vue?vue&type=style&index=0&id=34c7b90e&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c7b90e"]])

export default __exports__